export default {
  notification: {
    types: {
      ERROR: 'ERROR',
      MESSAGE: 'MESSAGE',
      NETWORK: 'NETWORK',
      INFO: 'INFO',
      DANGER: 'DANGER',
    },
    severity: {
      CRITICAL: 'CRITICAL',
      WARNING: 'WARNING',
      INFO: 'INFO',
      DEBUG: 'DEBUG',
      NOTICE: 'NOTICE',
    },
  },
  pages: {
    types: ['job', 'profiles', 'user'],
    job: 'job',
    profiles: 'profiles',
    user: 'user',
  },
  cards: {
    types: ['job', 'profile'],
    job: 'job',
    profile: 'profile',
  },
  accountTypes: {
    freelancer: 'freelancer',
    company: 'company',
    organization: 'organization',
    organisation: 'organisation',
    recruiter: 'recruiter',
    administrator: 'administrator',
    vendor: 'vendor',
    worker: 'worker',
  },
}

export const rate = {
  monthly: 'monthly',
  daily: 'daily',
  hourly: 'hourly',
  weekly: 'weekly',
}

export const COLOR = {
  BRAND_INDIGO: 'brand-indigo',
  BRAND_GREEN: 'brand-green',
  BRAND_YELLOW: 'brand-yellow',
  BRAND_RED: 'brand-red',
  BRANDGREEN200: 'brandgreen-200',
  INDIGO300: 'indigo-300',
  BRANDYELLOW100: 'brandyellow-200',
  BLUE: 'blue',
  GREEN: 'green',
  PURPLE: 'purple',
  ORANGE: 'orange',
  DARKGREEN: 'darkgreen',
  GRAY: 'gray',
  INDIGO: 'indigo',
  RED: 'red',
  LIGHTGRAY: 'lightgray',
  BLACK: 'black',
}

export const RELEVANCE = {
  MATCH: 0,
  CLIENTS: 1,
  ALL: 2,
}

export const RELEVANCE_LIST = {
  [RELEVANCE.ALL]: {
    _id: 'all',
    name: 'All jobs',
  },
  [RELEVANCE.MATCH]: {
    _id: 'matching',
    name: 'Jobs matching me',
  },
  [RELEVANCE.CLIENTS]: {
    _id: 'clients',
    name: 'Jobs from my clients',
  },
}

export const ChartTypes = {
  Line: 'line',
  Bar: 'bar',
  Stacked: 'stacked',
  StackedPercentage: 'stacked-percentage',
  Doughnut: 'doughnut',
}

export const ChartSwitchAbleTypes = {
  [ChartTypes.Line]: ChartTypes.Bar,
  [ChartTypes.Bar]: ChartTypes.Line,
  [ChartTypes.Stacked]: ChartTypes.Bar,
  [ChartTypes.StackedPercentage]: null,
  [ChartTypes.Doughnut]: null,
}

export const ModalSaveState = {
  FRESH: 'fresh',
  SAVING: 'saving',
  FAILED: 'failed',
  SAVED: 'saved',
}

export const ColorSchemes = {
  DEFAULT: 'default',
  INFO: 'info',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  BLACK: 'black',
}

export const SizeNames = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
}

export const PopperPlacements = {
  auto: 'auto',
  autoStart: 'auto-start',
  autoEnd: 'auto-end',
  top: 'top',
  topStart: 'top-start',
  topEnd: 'top-end',
  bottom: 'bottom',
  bottomStart: 'bottom-start',
  bottomEnd: 'bottom-end',
  right: 'right',
  rightStart: 'right-start',
  rightEnd: 'right-end',
  left: 'left',
  leftStart: 'left-start',
  leftEnd: 'left-end',
}

export const BidStatus = {
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  OPEN: 'open',
}
